import React, { FC } from 'react';
import { SettingsFormPageSkeleton } from '../settings/settingsSkeleton';

export const PlatformIntegrationSettingsPageSkeleton: FC = () => <SettingsFormPageSkeleton />;
